import React from 'react'

const OnlineCreditApproval = () => {
  return (
    <>
        <section className='common-wrap online-credit-wrap'>
            <div className='container'>
                <iframe 
                    src="https://extranet.dealercentric.com/Dashboard/Application/Showroom?Id=122234&crd=true" 
                    width="100%" 
                    height="1550px" 
                    frameBorder="0">
                </iframe>
            </div>
        </section>
    </>
  )
}

export default OnlineCreditApproval